export const BASE_API_URL = () => {
  return 'https://api-gw1.aws-east-2.rsvrprod.com/api/1';
};
